
import "./schedule.css";

import Header from "../../components/Header";
import Footer from "../../components/Footer";

import { useState, useEffect, useTransition, useRef } from "react";
import React from "react";

/* banco de dados */
import { db, auth } from "../../services/firebaseConnection";
import { getDoc, doc, collection, query, where, orderBy, getDocs, onSnapshot } from "firebase/firestore";

/* funções auxiliares */
import { db_basic } from "../../services/functions/functions.ts";

/* imagens */
import seta_prev_on from "../../assets/seta_prev_on.png";
import seta_next_on from "../../assets/seta_next_on.png";
import seta_prev_off from "../../assets/seta_prev_off.png";
import seta_next_off from "../../assets/seta_next_off.png";

/* links */
import { Link, useNavigate } from "react-router-dom";


export default function Schedule() {

    const [basic, setBasic] = useState([]);
    const [mondayBase, setMondayBase] = useState(normalizeMonday(getWeekRange().monday));
    const [mondayStart, setMondayStart] = useState(null);
    const [mondayEnd, setMondayEnd] = useState(null);

    const [semana, setSemana] = useState([]);
    const [hoverAgendamento, setHoverAgendamento] = useState(null);
    const [intervalSemana, setIntervalSemana] = useState(60);

    const navigate = useNavigate();

    const HORAS_UI = gerarHorasUI(intervalSemana);

    const tooltipRef = useRef(null);

    const [isPending, startTransition] = useTransition();

    const HORAS = Array.from({ length: 24 }, (_, i) => `${String(i).padStart(2, "0")}:00`);

    const isFirstWeek = mondayStart && mondayBase.getTime() <= mondayStart.getTime();
    const isLastWeek =  mondayEnd && mondayBase.getTime() >= mondayEnd.getTime();

    function getWeekRange(date = new Date()) {
    
        const day = date.getDay(); // 0 = domingo, 1 = segunda ...

        const monday = new Date(date);
        monday.setDate(date.getDate() - ((day + 6) % 7));

        const sunday = new Date(monday);
        sunday.setDate(monday.getDate() + 6);

        return {monday, sunday};
    }

 
    function formatToFirestoreDate(date) {
        return date.toISOString().slice(0,10).replace(/-/g,"");
    }

    useEffect(() => { window.scrollTo(0, 0); }, []);

    useEffect(() => {

        const loadBasic = async () => {
            
            const uid = auth.currentUser.uid;
            const bbd = await db_basic(uid);
            setBasic(bbd);
        
            //carrega informações
            try {


                

            } catch(erro) {

            }
        
        };

        loadBasic();

    }, []);


    useEffect(() => {if(!basic.agent?.id) return; carregarSemana(mondayBase)}, [mondayBase, basic.agent?.id]);


    useEffect(() => {
    
        if(!mondayBase || !basic.agent?.id) return;

        const diasSemanaIds = [];
        for(let i = 0; i < 7; i++) {
            const d = new Date(mondayBase);
            d.setDate(mondayBase.getDate() + i);
            diasSemanaIds.push(formatToFirestoreDate(d));
        }

        const aid = basic.agent.id;

        const logsRef = collection(db, "calendar_logs");
        const q = query(logsRef, where("id_agent", "==", aid), orderBy("date", "desc"));

        const unsubscribe = onSnapshot(q, (snapshot) => {

            snapshot.docChanges().forEach(change => {

            if(change.type !== "added") return;

            //proteção: pode vir change.doc undefined
            if(!change.doc || !change.doc.exists()) {
                console.warn("change.doc inexistente — ignorado");
                return;
            }

            const log = change.doc.data();

            let firestoreDia = log.dia;
            const hora = log.hora;
            const action = log.action;

            // normaliza o dia para YYYYMMDD
            if(firestoreDia.includes("-")) {
                firestoreDia = firestoreDia.replace(/-/g, "");
            } else if(firestoreDia.includes("/")) {
                const [dd, mm, yyyy] = firestoreDia.split("/");
                firestoreDia = `${yyyy}${mm.padStart(2, "0")}${dd.padStart(2, "0")}`;
            }

            if(!diasSemanaIds.includes(firestoreDia)) return;

            setSemana(prev => {
                
                const dias = [...prev];
                const idx = dias.findIndex(d => d.firestoreId === firestoreDia);
                
                if(idx === -1) return prev;

                const dia = {...dias[idx]};
                const horas = {...dia.horas};

                if(!horas[hora]) {
                    horas[hora] = { status: "nao_determinado" };
                }

                if(action === "ADD") {
                    horas[hora] = {
                        status: "ocupado",
                        paciente: {nome: log.nome || null, email: log.email || null, telefone: log.telefone || null, metadata: log.metadata || "", atendimento: log.atendimento || "", convenio: log.convenio || ""}
                    };
                }

                if(action === "CANCEL") {
                    horas[hora] = { status: "livre" };
                }

                dia.horas = horas;
                dias[idx] = dia;

                return dias;
                
            });

            });
        });

        return () => unsubscribe();

    }, [mondayBase, basic.agent?.id]);


    async function carregarSemana(mondayRef) {

        startTransition( async() => {

        try {

            let aid = basic.agent.id;
            let diasSemana = [];
            console.log(aid);

            // busca a primeira e última semana REAL do calendário
            const diasRef = collection(db, "calendar", aid, "dias");
            const diasSnap = await getDocs(diasRef);

            const mondaySet = new Set();

            diasSnap.forEach(docSnap => {
                const date = firestoreIdToDate(docSnap.id); // YYYYMMDD → Date
                const monday = normalizeMonday(getMonday(date));
                mondaySet.add(formatToFirestoreDate(monday));
            });

            if (mondaySet.size === 0) {
                throw new Error("Nenhuma semana encontrada no calendário");
            }

            const mondays = Array.from(mondaySet).sort(); // string YYYYMMDD

            const firstMonday = firestoreIdToDate(mondays[0]);
            const lastMonday  = firestoreIdToDate(mondays[mondays.length - 1]);

            setMondayStart(firstMonday);
            setMondayEnd(lastMonday);

            // busca a segunda-feira
            const mondayId = formatToFirestoreDate(mondayRef);
            const mondayRefDb = doc(db, "calendar", aid, "dias", mondayId);
            const mondaySnap = await getDoc(mondayRefDb);

            if(!mondaySnap.exists()) {
                throw new Error("Segunda-feira não configurada no calendário");
            }

            const mondayData = mondaySnap.data();
            const interval = Number(mondayData.interval) || 60;
            setIntervalSemana(interval);

            const HORAS_SEMANA = gerarHorasUI(interval);

            // loop normal da semana
            for(let i = 0; i < 7; i++) {

                const d = new Date(mondayRef);
                d.setDate(mondayRef.getDate() + i);

                const firestoreId = formatToFirestoreDate(d);
                const ref = doc(db, "calendar", aid, "dias", firestoreId);
                const snap = await getDoc(ref);

                let horas = {};

                if(!snap.exists()) {

                    HORAS_SEMANA.forEach(h => {
                        horas[h] = { status: "nao_determinado" };
                    });

                } else {

                    const dados = snap.data();
                    const horariosDb = dados.horarios || {};

                    HORAS_SEMANA.forEach(h => {

                    if(!horariosDb[h]) {
                        horas[h] = { status: "nao_determinado" };
                        return;
                    }

                    const item = horariosDb[h];

                    if(item.status === "livre") {
                        horas[h] = { status: "livre" };
                        return;
                    }

                    if(item.status === "ocupado") {
                        horas[h] = {
                        status: "ocupado",
                        paciente: item.paciente || null
                        };
                        return;
                    }

                    if(item.status === "indisponivel") {
                        horas[h] = { status: "indisponivel" };
                        return;
                    }

                    horas[h] = { status: "nao_determinado" };
                    });

                }

                const dia_formatado = firestoreId.substring(6, 8) + "." + firestoreId.substring(4, 6) + "." + firestoreId.substring(0, 4);

                diasSemana.push({firestoreId, dia: dia_formatado, date: d, weekday: d.toLocaleDateString("pt-BR", { weekday: "long" }).replace("-feira", "").trim().replace(/^\w/, c => c.toUpperCase()), horas});
            }

            setSemana(diasSemana);
        }
        catch(erro) {

        }
        })

    }


    function getMonday(date) {
    
        const d = new Date(date);
        const day = d.getDay(); // 0 = domingo
        const diff = d.getDate() - day + (day === 0 ? -6 : 1);
        d.setDate(diff);
        d.setHours(0, 0, 0, 0);
        return d;

    }


    function normalizeMonday(date) {
        const d = new Date(date);
        d.setHours(0, 0, 0, 0);
        return d;
    }


    function firestoreIdToDate(id) {
        return new Date(id.substring(0, 4), Number(id.substring(4, 6)) - 1, id.substring(6, 8));
    }


    function proximaSemana() {

        if(isLastWeek) return;

        const nova = new Date(mondayBase);
        nova.setDate(nova.getDate() + 7);
        setMondayBase(normalizeMonday(nova));

    }


    function semanaAnterior() {

        if(isFirstWeek) return;
    
        const nova = new Date(mondayBase);
        nova.setDate(nova.getDate() - 7);
        setMondayBase(normalizeMonday(nova));
    
    }


    function buscarSemanaPorData(dataStr) {
    
        const [dia, mes, ano] = dataStr.split("/");
        const d = new Date(`${ano}-${mes}-${dia}`);

        const monday = new Date(d);
        const day = monday.getDay();
        const diff = (day === 0 ? -6 : 1 - day);
        monday.setDate(monday.getDate() + diff);

        setMondayBase(monday);
    
    }


    function TooltipAgendamento({data, tooltipRef}) {

        const [pos, setPos] = React.useState({ top: 0, left: 0 });

        React.useLayoutEffect(() => {
            if(!tooltipRef.current || !data?.rect) return;

            const tooltipWidth = tooltipRef.current.offsetWidth;
            const spacing = 8;

            const left = data.lado === "left" ? data.rect.left - tooltipWidth - spacing : data.rect.right + spacing;

            setPos({ top: data.rect.top, left });

        }, [data, tooltipRef]);

        if(!data?.paciente) return null;

        return (
            <div ref={tooltipRef} className="tooltip-agendamento" style={{ top: pos.top, left: pos.left }}>

            {data.paciente?.atendimento && (<div className="agenda-tooltip-atendimento" style={{backgroundColor: data.paciente.atendimento === "consulta" ? "blue" : data.paciente.atendimento === "retorno" ? "purple" : "green"}}>{ data.paciente.atendimento === "consulta" || data.paciente.atendimento === "retorno" ? data.paciente.atendimento.toUpperCase() : "EXAME: " + data.paciente.atendimento }</div>)}
            <span className="agenda-tooltip-space"></span>

            {data.paciente?.convenio && (<div className="tooltip-linha">{data.paciente.atendimento === "retorno" ? "" : data.paciente.convenio === "particular" ? "Particular" : "Convênio: " + data.paciente.convenio}</div>)}
            <span className="agenda-tooltip-space"></span>

            <strong>{data.paciente?.nome || "Paciente"}</strong>

            <div className="tooltip-linha">📅 {data.dia} — {data.hora}</div>

            {data.paciente?.email && (<div className="tooltip-linha">✉️ {data.paciente.email}</div>)}

            {data.paciente?.telefone && (<div className="tooltip-linha">📞 {data.paciente.telefone}</div>)}
            
            </div>
        );
    }



    function gerarHorasUI(interval) {

        const horas = [];
        let minutos = 0;

        while (minutos < 24 * 60) {
            const h = String(Math.floor(minutos / 60)).padStart(2, "0");
            const m = String(minutos % 60).padStart(2, "0");
            horas.push(`${h}:${m}`);
            minutos += interval;
        }

        return horas;
    }



    return(
        <div className="context">
        
            <Header access={1}></Header>
        
                <div className="content">
                    
                    <div className="ft_topico">Agenda do cliente</div>
                    <div className="ft_descricao">Esse é a agenda do cliente, aqui você pode visualizar todos os agendamentos que seus pacientes realizaram.</div>
                    <div className="space"></div>

                    <div className="schedule_filters_box">
                        <div className="schedule_filters_box1"><img className="schedule_seta" onClick={semanaAnterior} src={isFirstWeek ? seta_prev_off : seta_prev_on} style={{cursor: isFirstWeek ? "" : "pointer"}}></img></div>
                        <div className="schedule_filters_box2">{ isPending ? "carregando ..." : (<>Semana:&nbsp;<span style={{color: "var(--SEC_1)", letterSpacing: "1px"}}>{semana[0]?.dia}</span>&nbsp;a&nbsp;<span style={{color: "var(--SEC_1)", letterSpacing: "1px"}}>{semana[6]?.dia}</span></>) }</div>
                        <div className="schedule_filters_box3"></div>
                        <div className="schedule_filters_box4"><img className="schedule_seta" onClick={proximaSemana} src={isLastWeek ? seta_next_off : seta_next_on} style={{cursor: isLastWeek ? "" : "pointer"}}></img></div>
                    </div>

                    <div className="schedule_space"></div>

                    <div className="schedule_panel">
                        <div className="schedule_panel_hour">
                            <span className="schedule_panel_hour_title"></span>
                            {HORAS_UI.map(hora => (
                                <span key={hora} className="schedule_panel_hour_item">{hora}</span>
                            ))}
                        </div>
                        <div className="schedule_panel_space"></div>
                        <div className="schedule_panel_content">

                            {isPending ? (<><span className="schedule_loading">aguarde ...<br />carregando agenda</span></>) : 
                            (<>
                            
                            { semana.map((dia, index) => (
                            <div className="schedule_panel_box">
                                <span className="schedule_panel_day">{semana[index]?.dia}</span>
                                <span className="schedule_panel_weekday">{semana[index]?.weekday}</span>
                                { Object.entries(semana[index]?.horas || {}).map(([hora, info]) => (
                                <>  
                                <span className="schedule_panel_hourtohour" style={{fontSize: info.status === "nao_determinado" || info.status === "indisponivel" || info.status === "bloqueado" ? "0.7rem" : info.status === "livre" ? "1rem" : "0.8rem", backgroundColor: info.status === "nao_determinado" || info.status === "indisponivel" ? "var(--HEAD_BK)" : info.status === "bloqueado" ? "var(--CNZ_4)" : info.status === "livre" ? "var(--SEC_4)" : "var(--PRI_4)", color: info.status === "nao_determinado" || info.status === "indisponivel" ? "var(--CNZ_3)" : info.status === "livre" ? "var(--SEC_1)" : info.status === "bloqueado" ? "var(--BAS_1)" : "var(--PRI_1)", cursor: info.status === "ocupado" ? "pointer" : "default"}} onMouseEnter={(e) => {

                                    const rect = e.currentTarget.getBoundingClientRect();
                                    const weekday = semana[index]?.weekday;
                                    const ladoEsquerdo = weekday === "Sexta" || weekday === "Sábado" || weekday === "Domingo";

                                    setHoverAgendamento({paciente: info.paciente, hora, dia: semana[index]?.dia, rect, lado: ladoEsquerdo ? "left" : "right"});
                                    
                                }}>{info.status === "nao_determinado" || info.status === "indisponivel" ? "não disponível" : info.status === "livre" || info.status === "bloqueado" ? info.status : info.paciente?.nome || ""}</span>
                                </>
                                ))}
                            </div>
                            ))}

                            </>)}

                        </div>
                    </div>

                    {hoverAgendamento?.paciente && (<TooltipAgendamento data={hoverAgendamento} tooltipRef={tooltipRef}/>)}

                    <div className="space"></div>
                    <span className="schedule_observacao">Obs.: Esse calendário é apenas para visualização dos eventos, para alterações de disponibilidades de dias e horários e/ou bloqueios de dias utlize:<br />Painel do Cliente &#8594; Alterar Agente &#8594; Alterar Configurações &#8594; Passo 4 - Calendário</span>
                    <div className="space_form"></div>
                    <span className="schedule_observacao">ou</span>
                    <div className="space_form"></div>
                    <Link className="schedule_link_agenda" to="/medical" state={{step: 3}}>ALTERAR AGENDA</Link>

                <div className="space"></div>
                <div className="space"></div>
                <div className="button_back_form"><button type="button" name="btbck" className="button2_form" onClick={() => navigate("/panel")}>VOLTAR</button></div>
                <div className="space"></div>
                <div className="space"></div>
                        
                </div>
                        
            <Footer access={1}></Footer>
                        
        </div>
    )
}